import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Tabs from './Tabs'
import PatientCard from './PatientCard'
import * as patientActions from '../../state/actions/selected-patient'
import { resetCurrentConversation } from '../../state/actions/current'
import { fetchMessageSettings } from '../../state/actions/message-settings'
import css from './styles.css'

class Patient extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.object,
    }).isRequired,
    selectCurrentPatient: PropTypes.func.isRequired,
    loadPatientWithRelations: PropTypes.func.isRequired,
    resetCurrentConversation: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    patient: PropTypes.shape({
      id: PropTypes.string,
    }),
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
      }),
    ),
    getTemplates: PropTypes.func.isRequired,
    hasScreenPop: PropTypes.bool.isRequired,
    hasRemindersTier2: PropTypes.bool.isRequired,
    hasReviews: PropTypes.bool.isRequired,
    pmsType: PropTypes.string,
    messageSettingsById: PropTypes.object,
    templateSettings: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    useCorrespondenceValues: PropTypes.bool.isRequired,
  }

  async componentDidMount() {
    const { activeLocation, getTemplates } = this.props
    this.loadPatient()
    await getTemplates(activeLocation && activeLocation.id)
  }

  loadPatient = () => {
    const {
      id,
      match: { params },
      selectCurrentPatient,
      loadPatientWithRelations,
    } = this.props
    const resolve = () => selectCurrentPatient(params.id)
    const reject = () => console.error('whoops')
    const init = new Promise(resolve, reject)
    init.then(() => loadPatientWithRelations(id))
  }

  componentWillUnmount() {
    this.props.resetPatient()
    this.props.resetCurrentConversation()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.selectCurrentPatient(nextProps.match.params.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.id && prevProps.id !== this.props.id) {
      this.props.loadPatientWithRelations(this.props.id, {
        with_reminders_contact_information: true,
      })
    }
  }

  render() {
    const {
      activeLocation,
      id,
      loadPatientWithRelations,
      isFetching,
      patient,
      groups,
      relatedPatients,
      accountHolders,
      hasScreenPop,
      hasRemindersTier2,
      hasReviews,
      location,
      pmsType,
      messageSettingsById,
      templateSettings,
      useCorrespondenceValues,
    } = this.props
    return (
      <div className={css.container}>
        {isFetching || !patient.id ? (
          <p>Loading ... </p>
        ) : (
          <div className={css.panelContainer}>
            <PatientCard
              id={id}
              loadPatientWithRelations={loadPatientWithRelations}
              patient={patient}
              groups={groups}
              relatedPatients={relatedPatients}
              accountHolders={accountHolders}
              hasRemindersTier2={hasRemindersTier2}
              hasReviews={hasReviews}
              location={location}
              pmsType={pmsType}
              useCorrespondenceValues={useCorrespondenceValues}
            />
            <Tabs
              activeLocation={activeLocation}
              patientId={patient.id}
              hasScreenPop={hasScreenPop}
              messageSettingsById={messageSettingsById}
              templateSettings={templateSettings}
            />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  selectedPatient: {
    id,
    isFetching,
    patient,
    relatedPatients,
    accountHolders,
    appointments,
    groups,
    location,
  },
  account: {
    auth: {
      hasRemindersTier2,
      hasReviews,
      hasScreenPop,
      pmsType,
      useCorrespondenceValues,
    },
    user: { activeLocation },
  },
  messageSettings: { byId: messageSettingsById, idsByType },
}) => {
  let templateSettings = []
  if (idsByType.hasOwnProperty('template')) {
    templateSettings = idsByType.template.map(
      settingId => messageSettingsById[settingId],
    )
  }
  return {
    activeLocation,
    patient,
    isFetching,
    id,
    relatedPatients,
    accountHolders,
    appointments,
    groups,
    hasScreenPop,
    hasRemindersTier2,
    hasReviews,
    location,
    messageSettingsById,
    pmsType,
    templateSettings,
    useCorrespondenceValues,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...patientActions,
      resetCurrentConversation,
      getTemplates: loc => fetchMessageSettings(loc, true),
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(Patient)



// WEBPACK FOOTER //
// ./src/components/PatientPage/index.js